import type { ComponentProps } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/utils.js';

export function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex select-none items-center gap-(--space-2)',
        'text-[length:var(--text-small)] font-medium text-ink',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-70',
        className,
      )}
      {...props}
    />
  );
}
